"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCouponWarning = exports.getCouponDetails = exports.getCouponUnit = void 0;
var Coupons_1 = require("../../Enums/Coupons");
var DateFormat_1 = require("../Dates/DateFormat");
var getCouponUnit = function (_a, _b) {
    var couponValueType = _a.couponValueType, couponValue = _a.couponValue, giftedProductName = _a.giftedProductName, couponMaxValue = _a.couponMaxValue, couponMinValue = _a.couponMinValue;
    var _c = _b === void 0 ? {} : _b, long = _c.long, max = _c.max, min = _c.min, showMinus = _c.showMinus;
    var prepend = showMinus ? '-' : '';
    var value = max ? couponMaxValue : min ? couponMinValue : couponValue;
    if (couponValueType === Coupons_1.CouponValueType.Percent && !max && !min)
        return long ? "".concat(value, "%&nbsp;de&nbsp;r\u00E9duction") : "".concat(prepend).concat(value, "%");
    if (couponValueType === Coupons_1.CouponValueType.Product && !max && !min)
        return long ? giftedProductName : "Produit&nbsp;offert";
    return long ? "".concat(value, "\u20AC&nbsp;de&nbsp;r\u00E9duction") : "".concat(prepend).concat(value, "\u20AC");
};
exports.getCouponUnit = getCouponUnit;
var getCouponDetails = function (coupon) {
    var details = [];
    if (coupon.comment)
        details.push(coupon.comment + '<br>');
    if (coupon.couponUsableOnlyFirstOrder)
        details.push('Uniquement sur la première commande.');
    if (coupon.couponMinValue)
        details.push("Pour une commande de ".concat((0, exports.getCouponUnit)(coupon, { min: true }), " minimum."));
    if (coupon.couponMaxValue)
        details.push("Dans la limite de ".concat((0, exports.getCouponUnit)(coupon, { max: true }), " de r\u00E9duction."));
    if (coupon.couponNbPerclientUseable)
        details.push("Utilisable ".concat(coupon.couponNbPerclientUseable, " fois."));
    if (coupon.couponEndDate)
        details.push("Expire le ".concat((0, DateFormat_1.tmsToFormat)(Number(coupon.couponEndDate), 'dd/MM/yyyy')));
    return details.length > 0 ? details.join(' ') : undefined;
};
exports.getCouponDetails = getCouponDetails;
var getCouponWarning = function (coupon) {
    var details = ['⚠️'];
    var isProduct = coupon.couponValueType === Coupons_1.CouponValueType.Product;
    if (coupon.clientMaxNumber > 1 && !isProduct)
        details.push('Code promo en quantité limitée.');
    if (isProduct)
        details.push('Dans la limite des stocks disponibles.');
    return details.length > 1 ? details.join(' ') : undefined;
};
exports.getCouponWarning = getCouponWarning;
//# sourceMappingURL=CouponWordings.js.map